export default __webpack_public_path__ + "static/blob-30-f5f5bc51ec2f13c8a4a23bd9d5cdd60d.svg";